import style from "./style.module.sass"
import SemiCircleProgressBar from "react-progressbar-semicircle"
import React from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "@material-ui/core/styles"
import { convertNumberToStringLocally } from "../../../../utils"
import { useSelector } from "react-redux"
import config from "../../../../config"

export default function FLESCHWrapperAi({ flesch, target, tabIndex }) {
    const { theme: { bgColors, borderColors, colors } } = useTheme()
    const { t, i18n: { language: i18nLanguage } } = useTranslation()
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT
    const percentage = flesch
    const color = flesch < target / 2 ? "#dd0d08" : flesch < target ? "#da7d27" : "#a8c721"

    return (
        <div className={style.bars} style={{ height: '99px',backgroundColor: bgColors.bgPrimary100}} tabIndex={tabIndex} title={t("accessibility_analysis_flesch")}>
            <p className={`m-0 ${style.bar_title}`} style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }}>{t("ai_gen_flesch")}</p>
            <SemiCircleProgressBar diameter={115} percentage={percentage} background={isContrast ? bgColors.bgRadial : bgColors.bgPrimary0} stroke={isContrast ? bgColors.bgCockpitBar : color} strokeWidth={8} />
            <div className={style.progressDesc} style={{top:'38px'}}>
                <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`m-0 ${style.title}`}>{t("FLESCH_analysis_minidash")}</p>
                <p className={`m-0 ${style.percentage}`} style={{ color: colors.colorPrimary1000 }}>{convertNumberToStringLocally(flesch, i18nLanguage)}</p>
                <div style={{ borderColor: borderColors.borderPrimary1000 }} className={`${style.maxSize} d-flex justify-content-center`}>
                    <p style={{ color: isContrast ? colors.colorContrast : colors.colorPrimary500 }} className={`m-0 ${style.zielwert}`}>{t("Target value")}:</p>
                    <p className={`m-0 ${style.zielwertNum} ml-1`} style={{ color: colors.colorText }}>{convertNumberToStringLocally(target, i18nLanguage)}</p>
                </div>
            </div>
        </div>
    )
}